<script setup>
import { defineProps } from "vue";

const props = defineProps({
  estatus: {
    type: String,
    required: true,
    default: "PENDIENTE",
  },
  plazo_aprobado: {
    type: Number,
  },
  motivo_rechazo: {
    type: String,
  },
});
</script>
<template>
  <div class="text-center mt-3">
    <div v-if="props.estatus == 'APROBADA'">
      <span class="badge badge-success badge-sm">{{ props.estatus }}</span>
      |
      <span class="badge badge-secondary badge-sm"
        >{{ props.plazo_aprobado }} MESES</span
      >
    </div>
    <div v-else-if="props.estatus == 'RECHAZADA'">
      <span class="badge badge-danger badge-sm">{{ props.estatus }}</span>
      <br />
      <span class="badge-sm text-uppercase fw-bold"
        >Motivo: {{ props.motivo_rechazo }}</span
      >
    </div>
    <div v-else>
      <span class="badge badge-secondary badge-sm">{{ props.estatus }}</span>
    </div>
  </div>
</template>
